export const REQUESTS_SUMMARY = 'requestsSummary';
export const DRS_RESTRICT_ACCESS = 'drsRestrictAccess';
export const EVERCALL_REGISTRATION_LIMIT = 'evercallRegistrationLimit';
export const EVERCALL_PARTICIPANT_COUNT_COLUMN = 'evercallParticipantCountColumn';

export const featureToggle = {
  [REQUESTS_SUMMARY]: {
    cookieName: REQUESTS_SUMMARY,
  },
  [DRS_RESTRICT_ACCESS]: {
    cookieName: DRS_RESTRICT_ACCESS,
  },
  [EVERCALL_REGISTRATION_LIMIT]: {
    cookieName: EVERCALL_REGISTRATION_LIMIT,
  },
  [EVERCALL_PARTICIPANT_COUNT_COLUMN]: {
    cookieName: EVERCALL_PARTICIPANT_COUNT_COLUMN,
  },
};
